import WhoWeAre from 'csdd_components/WhoWeAre';
import Footer from 'csdd_components/Footer';
import Newsletter from 'csdd_components/Newsletter';
import OurImpact from 'csdd_components/OurImpact';
import FeaturedArticle from 'csdd_components/FeaturedArticle';
import LatestVideos from 'csdd_components/LatestVideos';
import CarouselHome from 'csdd_components/CarouselHome';
import TopNavBar from 'csdd_components/TopNavBar';
import NewsAndInsights from 'csdd_components/NewsAndInsights';
import PartnersCompo from 'csdd_components/PartnersCompo';
import IndustryUpdatesCompo from 'csdd_components/IndustryUpdatesCompo';
import HomeNavBar from 'csdd_components/HomeNavBar';

const Homepage = () => {
  return (
    <>
      <TopNavBar />
      <HomeNavBar />
      <CarouselHome />
      <WhoWeAre />
      <NewsAndInsights />
      <IndustryUpdatesCompo />
      <LatestVideos />
      <PartnersCompo />
      <OurImpact />
      <FeaturedArticle />
      <Newsletter />
      <Footer />
    </>
  );
};
export default Homepage;
